import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { styleObjectGetBG } from "../common/StyleSeter";

function cleanUserId(value: string) {
  const text = String(value ?? "")
    .replace(/[\u200B-\u200D\uFEFF\u2060\u180E\u00AD]/g, "")
    .replace(/\u00A0/g, " ")
    .replace(/[\r\n\t]+/g, " ")
    .trim();
  const cut = text.search(/[\s([]/);
  if (cut > 0) return text.slice(0, cut).trim();
  return text;
}

const SearchInput = (props: any) => {
  const DD = useSelector((e: any) => e.domainDetails);

  const [search, setSearch] = useState("");
  const searchRef = useRef("");

  const {
    searchSubmit,
    placeholder,
    className,
    style,
    hide,
    btnName,
    outsideBtn,
    design,
    submitOnButtonOnly,
    normalizeUserId,
  } = props;

  const applySearchValue = (value: string) => {
    const next = normalizeUserId ? cleanUserId(value) : value;
    setSearch(next);
    searchRef.current = next;
    if (!submitOnButtonOnly && next === "") {
      searchSubmit("");
    }
  };

  const handleSearch = (e: any) => {
    applySearchValue(e.target.value);
  };

  const handlePaste = (e: any) => {
    if (!normalizeUserId) return;
    const pasted = e.clipboardData?.getData("text");
    if (typeof pasted !== "string") return;
    e.preventDefault();
    applySearchValue(pasted);
  };

  const handleButtonSubmit = () => {
    const raw = searchRef.current !== "" ? searchRef.current : search;
    const value = normalizeUserId
      ? cleanUserId(typeof raw === "string" ? raw : "")
      : typeof raw === "string"
        ? raw.trim()
        : raw;

    if (value === "") {
      // refresh
      window.location.reload();
      return;
    }
    searchSubmit(value);
  };

  const handleKeyDown = (e: any) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    handleButtonSubmit();
  };

  console.log({ search });

  return (
    <div
      className={`${className ? className : false} search-btn`}
      style={{ ...style, display: "flex", alignItems: "center" }}
    >
      <div className={`search_box common ${outsideBtn ? "outsideBtn" : ""}`}>
        <svg width="19" height="19" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.547 11.543H12l-.205-.172a4.539 4.539 0 001.06-2.914A4.442 4.442 0 008.41 4C5.983 4 4 5.989 4 8.457a4.442 4.442 0 004.445 4.457c1.094 0 2.12-.411 2.905-1.062l.206.171v.548L14.974 16 16 14.971l-3.453-3.428zm-4.102 0a3.069 3.069 0 01-3.077-3.086 3.068 3.068 0 013.077-3.086 3.069 3.069 0 013.076 3.086 3.069 3.069 0 01-3.076 3.086z"
            fill="rgb(30,30,30"
          ></path>
        </svg>
        <input
          type="search"
          name="search_filter_keyword"
          placeholder={placeholder ? placeholder : "Find Member..."}
          value={search}
          onChange={(e) => handleSearch(e)}
          onPaste={handlePaste}
          onKeyDown={handleKeyDown}
          readOnly
          onFocus={(e) => e.target.removeAttribute('readOnly')}
          onBlur={(e) => e.target.setAttribute('readOnly', 'true')}
          autoComplete="off"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          data-lpignore="true"
          data-form-type="other"
        />
        {design !== "in" && !hide && (
          <button
            type="button"
            style={styleObjectGetBG(
              DD?.colorSchema,
              outsideBtn ? true : false,
              true,
            )}
            onClick={handleButtonSubmit}
          >
            {btnName ? btnName : "Search"}
          </button>
        )}
      </div>
      {design == "in" && !hide && (
        <button
          type="button"
          style={{
            backgroundColor: "#ffb80c",
            color: "#1e1e1e",
            border: "1px solid #1e1e1e",
          }}
          className="height-32"
          onClick={handleButtonSubmit}
        >
          {btnName ? btnName : "Search"}
        </button>
      )}
    </div>
  );
};

export default SearchInput;
